enum seoszukaj {
  buzkaFill = '//images2.r.pl/r-pl/nuxt/szukaj/buzka-fill.svg',
  buzka = '//images2.r.pl/r-pl/nuxt/szukaj/buzka.svg',
  pencil = '//images2.r.pl/r-pl/nuxt/szukaj/pencil.svg',
  splash1 = '//images2.r.pl/r-pl/nuxt/szukaj/plama1.svg',
  splash2 = '//images2.r.pl/r-pl/nuxt/szukaj/plama2.svg',
  close = '//images2.r.pl/r-pl/nuxt/ui/close-circle.svg',
}

export default seoszukaj;
